import { createFileRoute } from '@tanstack/react-router';
import { RoleGuard } from '@/lib/auth/RoleGuard';
import { AuthenticatedShell } from '@/features/app/AuthenticatedShell';
import { FunderCatalogList } from '@/features/admin/funder-catalog/FunderCatalogList';

export const Route = createFileRoute('/admin/funders')({ component: FunderCatalogAdminPage });

function FunderCatalogAdminPage() {
  return (
    <RoleGuard allow={['PlatformAdmin']}>
      <AuthenticatedShell activeNavId="admin-funders">
        <FunderCatalogList />
      </AuthenticatedShell>
    </RoleGuard>
  );
}
